import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

export const useStyles = makeStyles((theme) => ({
  buttons: {
    width: "100%",
    display: "inline-block",
    marginTop: "20px",
    height: "40px",
    color: "#560e1a",
  },
}));

export const WrapperSignature = styled.div`
  width: 100%;
  height: calc(100vh - 300px);
  overflow-y: auto;
  border-radius: 4px;
  margin-top: 0;
  display: inline-block;
`;

export const IconButtonContainer = styled.div`
  width: 100%;
  margin: 8px 0 6px 0;
`;
